import script from "./AdminKlarvertragIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminKlarvertragIndex.vue?vue&type=script&setup=true&lang=js"

import "@/assets/styles/sfc/components/sites/AdminKlarvertragIndex.css?vue&type=style&index=0&id=afddf102&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-afddf102"]])

export default __exports__